export default __webpack_public_path__ + "media/images/checkbox-pink-b6d2b7f27825af301deb07a2dda4475d.svg";